// Individual exports for testing
import { call, put, takeLatest } from "redux-saga/effects"
import {
  GET_SHOW_OTHER_INDICATOR_WATCHER,
  SET_UPDATE_OTHER_INDICATOR_WATCHER,
} from "./constants"
import {
  getShowOtherIndicatorApi,
  setUpdateOtherIndicatorApi,
} from "../../../../utils/routes/routes-other-indicator"
import {
  getShowOtherIndicatorFailed,
  getShowOtherIndicatorSuccess,
  getUpdateOtherIndicatorFailed,
  getUpdateOtherIndicatorSuccess,
} from "./actions"
import { messageFailed, messageSuccess } from "../../../../utils/message"
import { push } from "connected-react-router"

export function* getShowOtherIndicatorSaga(action) {
  try {
    const data = action.payload
    const { data: response } = yield call(getShowOtherIndicatorApi, data.id)
    yield put(getShowOtherIndicatorSuccess(response))
  } catch (e) {
    yield put(getShowOtherIndicatorFailed())
  }
}

export function* setUpdateOtherIndicatorSaga(action) {
  const keyNotification = "other_notification_key"
  try {
    const params = action.payload
    const { data: code } = yield call(setUpdateOtherIndicatorApi, params)
    if (code.code === 200) {
      yield put(getUpdateOtherIndicatorSuccess())
      messageSuccess("Los cambios han sido guardados.", keyNotification)
      yield put(push("/control-panel#other-indicators"))
    } else {
      yield put(getUpdateOtherIndicatorFailed())
      messageFailed("Error al guardar cambios.", keyNotification)
    }
  } catch (e) {
    yield put(getUpdateOtherIndicatorFailed())
    messageFailed("Error al guardar cambios.", keyNotification)
  }
}

export default function* formIndicatorSaga() {
  yield takeLatest(GET_SHOW_OTHER_INDICATOR_WATCHER, getShowOtherIndicatorSaga)
  yield takeLatest(
    SET_UPDATE_OTHER_INDICATOR_WATCHER,
    setUpdateOtherIndicatorSaga
  )
}
